/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const catalogEntryListCompareCollectorActionsButtonClearSX: SxProps = {
	borderColor: 'primary.contrastText',
	backgroundColor: 'transparent',
	color: 'primary.contrastText',
	'&:hover': {
		backgroundColor: 'primary.main',
		color: 'primary.contrastText',
	},
};
